import React from 'react'
import { Form } from 'semantic-ui-react'

export default class BranchPhoneField extends React.PureComponent {
  render() {
    const { value, onChange, label, field } = this.props

    return (
      <Form.Input
        fluid
        label={label}
        placeholder="e.g +855 xx xxx xxx"
        onChange={e => onChange(field, e.target.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/branchPhoneField.js